<div #meetingTabContent
     *ngIf="meeting$ | async as meeting"
     class="d-flex flex-column meeting-tab-content"
     data-tour="meeting-tab-content">
    <div class="meeting-tab-header d-flex flex-column gap-1 pb-2">
        <div class="d-flex align-items-center meeting-tab-title">
            <h2 class="mb-0">{{meeting!.name}}</h2>
            <button *ngIf="meeting && meeting.supplementaryData && meeting.supplementaryData.purpose"
                    class="ms-auto meeting-shortcut-icon meeting-details-display-toggle py-0"
                    [(adaptCollapsibleButton)]="descriptionCollapsed"
                    [adaptTooltip]="descriptionCollapsed ? 'Show description': 'Hide description'"
                    data-test="meeting-tab-details-display-toggle"></button>
        </div>

        <adapt-meeting-shortcut-icons [meeting]="meeting"></adapt-meeting-shortcut-icons>
    </div>

    <dx-scroll-view class="ps-0"
                    direction="vertical"
                    showScrollbar="onHover"
                    [useNative]="false">
        <div *ngIf="meeting && meeting.supplementaryData && meeting.supplementaryData.purpose"
             [collapse]="descriptionCollapsed"
             [isAnimated]="true">
            <div class="pb-3">
                <div class="card meeting-description-card mb-0">
                    <div class="card-body p-2">
                        <adapt-see-more gradient>
                            <div [froalaView]="meeting.supplementaryData.purpose"></div>
                        </adapt-see-more>
                    </div>
                </div>
            </div>
        </div>

        <adapt-meeting-sidebar-agenda [meeting]="meeting"></adapt-meeting-sidebar-agenda>
    </dx-scroll-view>

    <div class="mt-auto d-flex flex-row bottom-panel">
        <adapt-meeting-progress-indicator [meeting]="meeting"></adapt-meeting-progress-indicator>
        <div class="live-meeting-control-buttons ms-auto">
            <button class="align-self-center btn btn-primary btn-move-meeting-to-page"
                    adaptTooltip="Move meeting to page"
                    adaptButtonIcon="fal fa-chevron-right"
                    [adaptBlockingClick]="moveToActiveMeetingPage"
                    [adaptBlockingClickParam]="meeting"
                    [unsubscribeOnDestroy]="false"
                    data-tour="move-meeting-button"
                    data-test="move-meeting-button"></button>
            <button *ngIf="canEditTeamMeeting"
                    class="align-self-center btn btn-primary btn-reschedule-meeting"
                    adaptTooltip="Reschedule meeting"
                    adaptButtonIcon="fal fa-sync-alt"
                    [adaptBlockingClick]="rescheduleMeeting"
                    [adaptBlockingClickParam]="meeting"
                    [unsubscribeOnDestroy]="false"
                    data-test="reschedule-meeting-button"></button>
            <button *ngIf="canEditTeamMeeting"
                    class="align-self-center btn btn-danger"
                    adaptButtonIcon="fal fa-stop-circle"
                    adaptTooltip="End meeting"
                    [adaptBlockingClick]="endMeeting"
                    [adaptBlockingClickParam]="meeting"
                    [unsubscribeOnDestroy]="false"
                    data-test="stop-meeting-button">End meeting
            </button>
        </div>
    </div>
</div>
